import { render, staticRenderFns } from "./InternalCorrectiveActionRequestsTable.vue?vue&type=template&id=46be96ce"
import script from "./InternalCorrectiveActionRequestsTable.vue?vue&type=script&lang=js"
export * from "./InternalCorrectiveActionRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports